import React from 'react';
import { EmptyTable } from 'Shared/components';
import { useBlockingRules } from 'Shared/services/Reznor/GetBlockingRules';
import { RulesTable } from 'BlockList/components/RulesTable';
import { useConfirmToggleRule } from 'BlockList/hooks/useConfirmToggleRule';

export const RulesPanel: React.FC = () => {
  const { data, loading, error, refetch } = useBlockingRules();

  const { openToggle, modal } = useConfirmToggleRule({
    onSuccess: refetch,
  });

  const hasRows = !error && data.length > 0;
  const showEmpty = !loading && !hasRows;
  const emptyMessage = error ?? 'No blocking rules configured.';

  return (
    <>
      <RulesTable
        rows={hasRows ? data : []}
        loading={loading}
        onToggle={openToggle}
        hasPagination={showEmpty}
      />

      {showEmpty && <EmptyTable>{emptyMessage}</EmptyTable>}

      {modal}
    </>
  );
};
